"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogFooter = exports.DialogBody = exports.DialogHeader = exports.Dialog = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const utils_1 = require("../utils"); // Utility function for conditional classNames
// Main Dialog component
const Dialog = ({ isOpen, onClose, children, closeOnOverlayClick = true, // Default value is true
className, positionClass }) => {
    const modalRef = (0, react_1.useRef)(null); // Ref to the dialog container
    const previousActiveElement = (0, react_1.useRef)(null); // Stores the element that was focused before opening the dialog
    // Handle side effects when the dialog opens or closes
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            previousActiveElement.current = document.activeElement; // Save the currently focused element
            modalRef.current?.focus(); // Focus the modal for accessibility
            document.body.style.overflow = 'hidden'; // Prevent background scrolling
            document.body.style.touchAction = 'none'; // Prevent iOS touch scroll
        }
        else {
            document.body.style.overflow = ''; // Restore background scrolling
            document.body.style.touchAction = '';
            previousActiveElement.current?.focus(); // Return focus to the previously active element
        }
        return () => {
            document.body.style.overflow = ''; // Cleanup on unmount
        };
    }, [isOpen]);
    // Handle keyboard interactions
    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            document.body.style.touchAction = "";
            onClose(); // Close dialog when Escape key is pressed
        }
        if (event.key === 'Tab' && modalRef.current) {
            const focusableElements = modalRef.current.querySelectorAll('button:not(:disabled), [href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])');
            const firstElement = focusableElements[0]; // First focusable element in the dialog
            const lastElement = focusableElements[focusableElements.length - 1]; // Last focusable element in the dialog
            // Handle shift+Tab to loop focus back to the last element
            if (event.shiftKey && document.activeElement === firstElement) {
                lastElement.focus();
                event.preventDefault();
            }
            // Handle Tab to loop focus back to the first element
            else if (!event.shiftKey && document.activeElement === lastElement) {
                firstElement.focus();
                event.preventDefault();
            }
        }
    };
    // Handle overlay click
    const handleOverlayClick = (event) => {
        if (closeOnOverlayClick && modalRef.current && !modalRef.current.contains(event.target)) {
            document.body.style.touchAction = "";
            onClose(); // Close dialog if overlay is clicked (if enabled)
        }
    };
    // Render nothing if the dialog is not open
    if (!isOpen)
        return null;
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { role: "dialog" // Accessibility role
        , "aria-modal": "true" // Accessibility attribute indicating the dialog is modal
        , className: (0, utils_1.cn)("fixed inset-0 z-[99999] flex items-center justify-center bg-[rgba(76,76,76,0.5)]", positionClass), onClick: handleOverlayClick, onKeyDown: (e) => handleKeyDown(e) },
        react_1.default.createElement("div", { ref: modalRef, tabIndex: -1, className: (0, utils_1.cn)("bg-white p-6 rounded-lg shadow-xl w-full max-w-md transform transition-transform scale-100 animate-modal-scale", className), onClick: (e) => e.stopPropagation() }, children)), document.body // Render dialog into the root of the document
    );
};
exports.Dialog = Dialog;
// Subcomponents with reusable styles and optional className
/**
 * DialogHeader: A styled header for the dialog.
 */
const DialogHeader = ({ children, className }) => (react_1.default.createElement("header", { className: (0, utils_1.cn)("flex justify-between items-center", className) }, children));
exports.DialogHeader = DialogHeader;
/**
 * DialogBody: A styled body section for the dialog.
 */
const DialogBody = ({ children, className }) => (react_1.default.createElement("div", { className: (0, utils_1.cn)("py-4", className) }, children));
exports.DialogBody = DialogBody;
/**
 * DialogFooter: A styled footer for the dialog.
 */
const DialogFooter = ({ children, className }) => (react_1.default.createElement("footer", { className: (0, utils_1.cn)("text-right", className) }, children));
exports.DialogFooter = DialogFooter;
